module.exports = __webpack_public_path__ + "static/clients-f618ef122f2c388140a24f6cea507285.png";